export default __webpack_public_path__ + "static/media/home-restaurant-img-08.879cca45.jpg";